<template>
  <div class="background-image" :style="{ backgroundImage: `url(${image})` }">
  </div>
</template>

<script>
import image from '../static/images/test-bg.jpg'
import Vue from 'vue'
export default {
  name:"BackgroundImage",
  components: {
  },
  data: () => ({
    // image: '/images/test-bg.jpg'
  }),
  props: {
    image: String
  },
  computed: {
    imageSrc()  {
        return image
    }
  }

}
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  .background-image
    background-repeat no-repeat
    background-size cover
    background-position center

</style>